import React from 'react';
import Button from '../../../components/shared/Button/Button';

interface Props {
  paybill: string;
  account: string;
  amount: string;
  checking: boolean;
  onCheck: () => void;
  onClose: () => void;
}

export const ManualPaymentModal: React.FC<Props> = ({
  paybill, account, amount, checking, onCheck, onClose,
}) => {
  const steps = [
    'Open M-Pesa on your phone',
    'Select Lipa na M-Pesa',
    'Select Paybill',
    `Enter the Paybill number: ${paybill}`,
    `Enter the Account number: ${account}`,
    `Enter the Amount: KES ${amount}`,
    'Enter your M-Pesa PIN and confirm',
    'Wait for confirmation SMS',
    "You'll receive booking confirmation via SMS",
  ];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900">Manual Payment Steps</h2>
          <button onClick={onClose} aria-label="Close" className="text-slate-400 hover:text-slate-600">×</button>
        </div>
        <p className="mb-2 text-sm font-semibold text-slate-800">📱 M-Pesa Paybill Payment</p>
        <div className="mb-4 rounded-lg bg-sky-50 p-3 text-sm text-slate-700">
          <p><span className="font-medium">Paybill:</span> <span className="font-mono">{paybill}</span></p>
          <p><span className="font-medium">Account:</span> <span className="font-mono">{account}</span></p>
          <p><span className="font-medium">Amount:</span> KES {amount}</p>
        </div>
        <ol className="mb-4 list-decimal space-y-1 pl-5 text-sm text-slate-700">
          {steps.map((s) => (<li key={s}>{s}</li>))}
        </ol>
        <p className="mb-4 text-xs text-slate-500">
          Note: Please pay within 15 minutes of booking. Otherwise, your booking will be cancelled.
        </p>
        <div className="flex gap-3">
          <Button variant="secondary" type="button" onClick={onClose}>Retry Payment</Button>
          <Button type="button" loading={checking} onClick={onCheck}>Check Payment</Button>
        </div>
      </div>
    </div>
  );
};
